import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-course-tags',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './course-tags.component.html',
  styleUrl: './course-tags.component.scss',
})
export class CourseTagsComponent {
  tags = input<string[]>([]);
}
